import React, { useState } from 'react';
import {
  Box,
  Switch,
  Typography,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import ReCAPTCHA from 'react-google-recaptcha';
import { withLocale } from '../../../hocs/withLocale';
import apiConfig from '../../../infrastructure/Config';

export interface WithRecaptchaProps {
  onVerify: (verified: boolean) => void;
}

interface RecaptchaProps extends WithRecaptchaProps {
  translate: (key: string) => string;
  domain: { domain: { hreflang: string } };
}

const RecaptchaComponent: React.FC<RecaptchaProps> = ({ translate, onVerify, domain }) => {
  const [verified, setVerified] = useState(false);
  const [dialogOpen, setDialogOpen] = useState(false);

  const handleSwitchClick = () => {
    if (verified) {
      // Uncheck — reset verification
      setVerified(false);
      onVerify(false);
    } else {
      // Open captcha dialog
      setDialogOpen(true);
    }
  };

  const handleCaptchaSuccess = (token: string | null) => {
    if (token) {
      setVerified(true);
      setDialogOpen(false);
      onVerify(true);
    }
  };

  const handleDialogClose = () => {
    setDialogOpen(false);
    // Captcha not completed — keep switch off
    setVerified(false);
    onVerify(false);
  };

  return (
    <>
      <Box display="flex" alignItems="center" style={{ gap: 8, cursor: 'pointer' }} onClick={handleSwitchClick}>
        <Switch
          checked={verified}
          color="primary"
          size="small"
          // Prevent double-fire from Box onClick
          onClick={(e) => e.stopPropagation()}
          onChange={handleSwitchClick}
        />
        <Typography style={{ fontSize: 16, color: '#374151', userSelect: 'none' }}>
          {translate('common.notARobot')}
        </Typography>
      </Box>

      <Dialog open={dialogOpen} onClose={handleDialogClose} maxWidth="xs">
        <DialogTitle disableTypography style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', paddingBottom: 8 }}>
          <Typography style={{ fontWeight: 700, fontSize: 16, color: '#111827' }}>
            {translate('common.notARobot')}
          </Typography>
          <IconButton size="small" onClick={handleDialogClose}>
            <CloseIcon fontSize="small" />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <Box display="flex" justifyContent="center" pb={2}>
            <ReCAPTCHA
              hl={domain?.domain?.hreflang}
              sitekey={apiConfig.recaptchaSiteKey}
              onChange={handleCaptchaSuccess}
            />
          </Box>
        </DialogContent>
      </Dialog>
    </>
  );
};

export const Recaptcha = withLocale(RecaptchaComponent);
